<template>
  <div class="w-full max-h-[500px] relative">
    <div
      v-if="type == 'video'"
      class="absolute top-0 w-full md:w-2/3 bottom-0 z-10 px-3 md:pl-10"
    >
      <div class="flex flex-col justify-between h-full">
        <div>
          <div
            class="
              text-accent
              font-bold
              mt-1
              sm:mt-3
              md:mt-8
              text-sm
              md:text-lg
            "
          >
            # {{$t('homepage.main_banner.trending')}}
          </div>
          <h1
            class="
              text-secondary
              font-semibold
              text-lg
              sm:text-2xl
              md:text-4xl
              mt-2
              sm:mt-3
              md:mt-16
              line-clamp-2
            "
          >
            {{ value.name }}
          </h1>
          <div
            class="
              text-secondary-variation
              mt-1
              sm:mt-3
              md:mt-10
              font-semibold
              text-sm
              md:text-lg
              line-clamp-1
            "
          >
            {{ value.description }}
          </div>
        </div>
        <div class="flex items-center pb-4 md:pb-12 space-x-2 md:space-x-6">
          <button
            class="
              bg-black
              text-secondary
              px-3
              sm:px-4
              md:px-6
              py-1.5
              sm:py-3
              md:py-3
              font-bold
              rounded-xl
              md:text-2xl
              hover:bg-accent
              transition-default
            "
          >
            <router-link
              :to="{ name: 'Video', params: { id: value.slug } }"
              class="flex items-center space-x-1 md:space-x-2"
            >
              <PlayIcon class="h-6 w-6" />
              <span>{{$t('homepage.main_banner.play_now_button')}}</span>
            </router-link>
          </button>
        </div>
      </div>
    </div>
    <div
      class="
        absolute
        top-0
        right-0
        left-0
        bottom-0
        bg-gradient-to-r
        from-primary
        via-primary
        to-transparent
        opacity-90
      "
    ></div>
    <img
      class="
        object-cover object-center
        min-h-56
        max-h-[500px]
        w-auto
        md:w-full
        rounded-xl
      "
      :src="type == 'video' ? value.thumbnail : value"
      :alt="type == 'video' ? value.name : 'SpicyGum Banner'"
    />
  </div>
</template>

<script>
import PlayIcon from "@/components/icons/PlayIcon";
export default {
  name: "MainBanner",
  props: {
    type: {
      type: String,
      required: true,
    },
    value: {
      type: [String, Object],
      required: true,
    },
  },
  components: {
    PlayIcon,
  },
};
</script>

<style>
</style>